import {collection, query, where, getDocs, onSnapshot} from 'firebase/firestore';
import {orderDayPlan} from './orderReadPlan';

export class OrderReads {
  constructor(db, name, check, changed) {
    Object.assign(this, {db, name, check, changed});
    this.snapshots = new Map();
    this.pending = new Map();
    this.stops = [];
    this.listening = new Set();
    this.closed = false;
    this.version = 0;
  }
  assertCurrent() {
    this.check();
    if (this.closed) throw new Error('Sipariş kapsamı değişti. Yeniden açın.');
  }
  targets(date) {
    const base = collection(this.db, this.name);
    return date ? orderDayPlan(date).map(filters => query(base, ...filters.map(f => where(f.field,f.op,f.value)))) : [base];
  }
  key(date, index) { return `${date || 'all'}:${index}`; }
  listen(date) {
    const scope=date || 'all';
    if(this.listening.has(scope)) return;
    this.listening.add(scope);
    this.targets(date).forEach((target,index) => {
      const key=this.key(date,index);
      this.stops.push(onSnapshot(target,{includeMetadataChanges:true},snapshot => {
        if (this.closed) return;
        try { this.assertCurrent(); } catch { return; }
        const changed=!this.snapshots.has(key) || !snapshot.docChanges || snapshot.docChanges().length > 0;
        this.snapshots.set(key,snapshot);
        if (changed) this.changed();
      },error => { if (!this.closed) console.warn('Orders sync notice:',error); }));
    });
  }
  async read(date) {
    this.assertCurrent();
    const snapshots=await Promise.all(this.targets(date).map((target,index) => {
      const key=this.key(date,index);
      if (this.snapshots.has(key)) return this.snapshots.get(key);
      if (this.pending.has(key)) return this.pending.get(key);
      const version=this.version;
      const task=getDocs(target).then(snapshot => {
        this.assertCurrent();
        if(version!==this.version && !this.snapshots.has(key)) throw new Error('Siparişler değişti. Yeniden açın.');
        return this.snapshots.get(key) || snapshot;
      }).finally(()=>{ if(this.pending.get(key)===task) this.pending.delete(key); });
      this.pending.set(key,task);
      return task;
    }));
    this.assertCurrent();
    return {docs:[...new Map(snapshots.flatMap(s=>s.docs.map(d=>[d.id,d]))).values()]};
  }
  close() {
    this.closed=true;
    this.stops.forEach(stop=>stop());
    this.snapshots.clear();
    this.pending.clear();
  }
  invalidate() {
    this.version++;
    this.snapshots.clear();
    this.pending.clear();
  }
}
